<ul class="timeline">
  <li class="timeline-item" routerLinkActive="active" [ngClass]="sideBarLinks[0].selected == true ? 'active' : ''">
    <a href="javascript:void(0);" routerLink="/skills" title="skill" >
      <span class="timeline-point-circle fill" ></span>
      <p> Skills </p>
    </a>
  </li>
  <li class="timeline-item" routerLinkActive="active" [ngClass]="sideBarLinks[1].selected == true ? 'active' : ''">
    <a href="javascript:void(0);" routerLink="/education" title="education" *ngIf="sideBarLinks[1].selected == true">
      <span class="timeline-point-circle " routerLinkActive="fill" [ngClass]="sideBarLinks[1].selected == true ? 'fill' : ''"></span>
      <p> Education </p>
    </a>
    <a title="education"  *ngIf="sideBarLinks[1].selected != true">
      <span class="timeline-point-circle "></span>
      <p> Education </p>
    </a>
  </li>
  <li class="timeline-item" routerLinkActive="active" [ngClass]="sideBarLinks[2].selected == true ? 'active' : ''">
    <a href="javascript:void(0);" routerLink="/experience" title="Work experience" *ngIf="sideBarLinks[2].selected == true">
      <span class="timeline-point-circle " routerLinkActive="fill" [ngClass]="sideBarLinks[2].selected == true ? 'fill' : ''"></span>
      <p> Work experience </p>
    </a>
    <a title="Work experience"  *ngIf="sideBarLinks[2].selected != true">
      <span class="timeline-point-circle "></span>
      <span> Work experience </span>
    </a>
  </li>
  <li class="timeline-item" routerLinkActive="active" [ngClass]="sideBarLinks[3].selected == true ? 'active' : ''">
    <a href="javascript:void(0);" routerLink="/volunteer" title="Volunteer Experience"  *ngIf="sideBarLinks[3].selected == true">
      <span class="timeline-point-circle " routerLinkActive="fill" [ngClass]="sideBarLinks[3].selected == true ? 'fill' : ''"></span>
      <p> Volunteer experience </p>
    </a>
    <a title="Volunteer Experience" *ngIf="sideBarLinks[3].selected != true">
      <span class="timeline-point-circle " ></span>
      <p> Volunteer experience </p>
    </a>
  </li> 
  <li class="timeline-item" routerLinkActive="active" [ngClass]="sideBarLinks[4].selected == true ? 'active' : ''">
    <a href="javascript:void(0);" routerLink="/projects" title="Projects Undertaken"  *ngIf="sideBarLinks[4].selected == true">
      <span class="timeline-point-circle " routerLinkActive="fill" [ngClass]="sideBarLinks[4].selected == true ? 'fill' : ''"></span>
      <p>Projects undertaken</p>
    </a>
    <a title="Projects undertaken"  *ngIf="sideBarLinks[4].selected != true">
      <span class="timeline-point-circle "></span>
      <p>Projects Undertaken</p>
    </a>
  </li>  
  <li class="timeline-item" routerLinkActive="active" [ngClass]="sideBarLinks[5].selected == true ? 'active' : ''">
    <a href="javascript:void(0);" routerLink="/awards" title="Awards & honors" *ngIf="sideBarLinks[5].selected == true">
      <span class="timeline-point-circle " routerLinkActive="fill" [ngClass]="sideBarLinks[5].selected == true ? 'fill' : ''"></span>
      <p>Awards & honors</p>
    </a>
    <a title="Awards & honors" *ngIf="sideBarLinks[5].selected != true">
      <span class="timeline-point-circle "></span>
      <p>Awards & honors</p>
    </a>
  </li> 
  <li class="timeline-item" routerLinkActive="active" [ngClass]="sideBarLinks[6].selected == true ? 'active' : ''">
    <a href="javascript:void(0);" routerLink="/licenese" title="Licenses" *ngIf="sideBarLinks[6].selected == true">
      <span class="timeline-point-circle " routerLinkActive="fill" [ngClass]="sideBarLinks[6].selected == true ? 'fill' : ''"></span>
      <p>Licenses / certifications</p>
    </a>
    <a title="Licenses" *ngIf="sideBarLinks[6].selected != true">
      <span class="timeline-point-circle " ></span>
      <p>Licenses / certifications</p>
    </a>
  </li> 
  <li class="timeline-item" routerLinkActive="active" [ngClass]="sideBarLinks[7].selected == true ? 'active' : ''">
    <a href="javascript:void(0);" routerLink="/language" title="Add languages" *ngIf="sideBarLinks[7].selected == true">
      <span class="timeline-point-circle " routerLinkActive="fill" [ngClass]="sideBarLinks[7].selected == true ? 'fill' : ''"></span>
      <p>Add languages</p>
    </a>
    <a title="Add languages" *ngIf="sideBarLinks[7].selected != true">
      <span class="timeline-point-circle " ></span>
      <p>Add languages</p>
    </a>
  </li>  
  <li class="timeline-item" routerLinkActive="active" [ngClass]="sideBarLinks[8].selected == true ? 'active' : ''">
    <a href="javascript:void(0);" routerLink="/jobs" title="Job preferences" *ngIf="sideBarLinks[8].selected == true">
      <span class="timeline-point-circle " routerLinkActive="fill" [ngClass]="sideBarLinks[8].selected == true ? 'fill' : ''"></span>
      <p>Job preferences</p>
    </a>
    <a title="Job preferences" *ngIf="sideBarLinks[8].selected != true">
      <span class="timeline-point-circle " ></span>
      <p>Job preferences</p>
    </a>
  </li>     
</ul>